import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from '@aviv-unified-frontend/runtime/router';
import { Box } from '@gemini/core';
import { Error500Illu } from '@/assets/icons/Error500Illu';
import ErrorContent from '@/components/ErrorContent';
import { TrackingViewPropsError } from '@/entities/enums/Tracking';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
import { useThorPageView } from '@/hooks/useThorPageView/useThorPageView';
export const Custom500 = () => {
    const { t } = useShellTranslation();
    const navigate = useNavigate();
    useThorPageView(TrackingViewPropsError.ERROR_500);
    return (_jsx(Box, { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "spacing.56", children: _jsx(ErrorContent, { title: t('unavailable_error_page.h1'), description: `${t('unavailable_error_page.general_explanation')} ${t('unavailable_error_page.advice')}`, image: Error500Illu, startButtonProps: {
                label: t('unavailable_error_page.link_to_homepage'),
                action: () => navigate('/'),
            } }) }));
};
